import { t } from "./i18n";

export function newPasswordProblem(password: string): string {
  if (password.length < 8) return t("Ο κωδικός πρόσβασης θέλει τουλάχιστον 8 χαρακτήρες.");
  if (password.length > 256) return t("Ο κωδικός πρόσβασης είναι πολύ μεγάλος.");
  return ""; // The server also rejects common passwords.
}

export async function legacyPasswordHash(password: string): Promise<string> {
  const bytes = new TextEncoder().encode("kitchen-orders:" + password);
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}
